// extracted by mini-css-extract-plugin
export default {"swap":"wiqMdVhdSLizgRTcCdnG","animation-standard":"eIJk9k32LvF4hupCnFMi","animation-accordion":"oreXoexvHj_i23qM0xy3","swapItem":"D8kcRq1Q_Id8lmF1XMt0"};